"use strict";

document.addEventListener('DOMContentLoaded', function () {
  var partnerSliders = document.querySelectorAll('.partner-slider-container');
  partnerSliders.forEach(function (slider) {
    var swiper = new Swiper(slider.querySelector('.swiper-container'), {
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
      slidesPerView: 5.6,
      spaceBetween: 30,
      breakpoints: {
        320: {
          slidesPerView: 1.4,
          spaceBetween: 10
        },
        640: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        1024: {
          slidesPerView: 5.6,
          spaceBetween: 30
        }
      },
      navigation: {
        nextEl: slider.querySelector('.partner-container-slider-arrow-next'),
        prevEl: slider.querySelector('.partner-container-slider-arrow-prev')
      }
    });
  });
});